import axios, { AxiosInstance } from "axios";
import { TOKEN_KEY } from "../../constants";

// Payment API instance
const paymentApi = axios.create({
  baseURL: process.env.REACT_APP_PAYMENT_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420",
  },
});

// Main API instance
const mainApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420",
  },
});

const addAuthInterceptor = (apiInstance: AxiosInstance) => {
  apiInstance.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  apiInstance.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      // Handle common errors
      if (error.response?.status === 401) {
        // Handle unauthorized access
        localStorage.removeItem(TOKEN_KEY);
      }
      return Promise.reject(error);
    }
  );
};

// Add auth interceptors to both instances
addAuthInterceptor(paymentApi);
addAuthInterceptor(mainApi);

export { paymentApi, mainApi };
export default paymentApi;
